"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseUri = require("../Support/BaseUri");
function image(fileName) {
    return BaseUri.compose()
        .segment('grids')
        .segment('images')
        .segment(fileName.toString())
        .toString();
}
exports.image = image;
